var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Button, Card, Flex, Popconfirm, theme, Typography, } from '@robinpowered/ui-kit';
import { useEventDetailContext, } from '../../context/EventDetailContextProvider';
import { CollapsibleCard } from '../../../components/common/CollapsibleCard';
import { keyframes } from '@emotion/react';
import { calcLogarithmicGrowth } from '../../../utils/utils';
import { useTranslation } from 'react-i18next';
import { SpaceAmenities } from '../../../components/SpaceDetails/SpaceAmenities';
import { ServiceRequest } from './ServiceRequest';
import { SpaceBuffer } from './SpaceBuffer';
import { SpaceRequest } from './SpaceRequest';
import { EventDetailsSuccessActions } from '../../types';
import { CheckInStatus } from '../CheckInStatus';
export var SpaceCard = function (_a) {
    var _b;
    var timeFormat = _a.timeFormat;
    var t = useTranslation('meetingRooms').t;
    var _c = useEventDetailContext(), spaceData = _c.spaceData, event = _c.event, removeSpaceInvitee = _c.removeSpaceInvitee, onError = _c.onError, refetchEvent = _c.loadEvent, onSuccess = _c.onSuccess;
    var spaces = useMemo(function () { return Array.from(spaceData.values()); }, [spaceData]);
    /* There can only be 1 delete operation at a time */
    var _d = __read(useState(null), 2), isRemovingSpace = _d[0], setisRemovingSpace = _d[1];
    var eventUid = event === null || event === void 0 ? void 0 : event.uid;
    /* @TODO move this to a hook for managing spaces */
    var handleRemoveSpace = useCallback(function (spaceInviteeId, spaceId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event === null || event === void 0 ? void 0 : event.id)) {
                        return [2 /*return*/];
                    }
                    setisRemovingSpace(spaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeSpaceInvitee(event.id, spaceInviteeId)];
                case 2:
                    result = _a.sent();
                    if (result) {
                        // Always refetch after successful delete - pass false to allow state updates
                        refetchEvent(false);
                        onSuccess(EventDetailsSuccessActions.REMOVE_SPACE_INVITEE);
                    }
                    else {
                        onError(new Error('Failed to remove space, please try again.'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setisRemovingSpace(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [removeSpaceInvitee, event === null || event === void 0 ? void 0 : event.id, refetchEvent, onError, onSuccess]);
    var userCanUpdateEvent = !!((_b = event === null || event === void 0 ? void 0 : event.event_permissions) === null || _b === void 0 ? void 0 : _b.update);
    if (!spaces)
        return null;
    var disableToggle = spaces.length < 3;
    if (!eventUid)
        return null;
    return (_jsx(_Fragment, { children: disableToggle ? (_jsx(Flex, { gap: 12, vertical: true, children: _jsx(SpaceCardList, { eventSpaces: spaces, eventUid: eventUid, userCanUpdateEvent: userCanUpdateEvent, onRemoveSpace: handleRemoveSpace, isRemovingSpace: isRemovingSpace, timeFormat: timeFormat }) })) : (_jsx(CollapsibleCard, { title: t('eventDetails.space.title_plural', {
                count: spaces.length,
            }), defaultExpanded: true, children: _jsx(SpaceCardList, { eventSpaces: spaces, eventUid: eventUid, userCanUpdateEvent: userCanUpdateEvent, onRemoveSpace: handleRemoveSpace, isRemovingSpace: isRemovingSpace, timeFormat: timeFormat }) })) }));
};
var SpaceCardList = function (_a) {
    var eventSpaces = _a.eventSpaces, eventUid = _a.eventUid, userCanUpdateEvent = _a.userCanUpdateEvent, onRemoveSpace = _a.onRemoveSpace, isRemovingSpace = _a.isRemovingSpace, timeFormat = _a.timeFormat;
    var token = theme.useToken().token;
    var t = useTranslation('meetingRooms').t;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var event = useEventDetailContext().event;
    var spaceActions = function (space) {
        var userCanRemoveSpace = userCanUpdateEvent && !space.isOrganizer;
        if (!userCanRemoveSpace)
            return [];
        return [
            _jsx(Popconfirm, { title: tSpaceBooking('remove_space.title'), description: tSpaceBooking('remove_space.description'), onConfirm: function () { return onRemoveSpace(space.inviteeId, space.id); }, children: _jsx(Button, { type: "text", style: {
                        width: '100%',
                        alignSelf: 'flex-start',
                        color: token.colorError,
                    }, disabled: !!isRemovingSpace, loading: isRemovingSpace === space.id, children: isRemovingSpace === space.id
                        ? t('eventDetails.space.removing_space')
                        : t('eventDetails.space.remove_space') }, space.id) }, space.id),
        ];
    };
    return (_jsx(Flex, { gap: 12, vertical: true, children: eventSpaces.map(function (space, index) {
            var _a;
            var actions = spaceActions(space);
            return (
            /* @TODO[Spaces] This component is reused a lot, move to common file */
            _jsxs(SpaceCardWrapper, { token: token, index: index, actions: actions, children: [_jsxs(SpaceCardBody, { children: [_jsxs(SpaceInfo, { children: [_jsx(Typography.Title, { level: 5, style: { marginBottom: 0 }, children: space.name }), _jsx(Typography.Text, { type: "secondary", style: { fontSize: 12 }, children: t('eventDetails.formattedSpaceName.name', {
                                            spaceName: space.name,
                                            locationName: (_a = space.location) === null || _a === void 0 ? void 0 : _a.name,
                                        }) }), _jsx(SpaceAmenities, { capacity: (space === null || space === void 0 ? void 0 : space.capacity) || undefined, amenities: (space === null || space === void 0 ? void 0 : space.space_amenities.map(function (amenity) { return ({
                                            id: amenity.id,
                                            quantity: amenity.quantity,
                                            amenityId: amenity.amenity_id,
                                            name: amenity.amenity.name,
                                        }); })) || [] })] }), space.image && (_jsx(SpaceImage, { width: 50, height: 50, src: space.image, alt: space.name }))] }), space.id === (event === null || event === void 0 ? void 0 : event.space_id) && (_jsx(Flex, { style: { padding: '0px 12px 12px 12px' }, children: _jsx(CheckInStatus, { timeFormat: timeFormat }) })), space.is_managed && space.reservationApproval && (_jsx(SpaceRequest, { reservationApproval: space.reservationApproval, space: space })), space.id && eventUid && (_jsx(ServiceRequest, { spaceId: space.id.toString() })), space.buffer && _jsx(SpaceBuffer, { space: space })] }, space.id));
        }) }));
};
var fadeDown = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    top: -30px;\n  }\n  to {\n    opacity: 1;\n    top: 0px;\n  }\n"], ["\n  from {\n    opacity: 0;\n    top: -30px;\n  }\n  to {\n    opacity: 1;\n    top: 0px;\n  }\n"])));
var SpaceCardWrapper = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 0px;\n\n  animation: ", ";\n  animation-duration: ", "s;\n  animation-timing-function: cubic-bezier(0.65, -0.25, 0.38, 1.19);\n  animation-fill-mode: forwards;\n\n  .ant-card-body {\n    padding: 0px;\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n\n  .ant-card-actions {\n    padding: ", "px;\n    background: ", ";\n\n    li {\n      margin: 0px;\n    }\n  }\n"], ["\n  border-radius: 4px;\n  padding: 0px;\n\n  animation: ", ";\n  animation-duration: ", "s;\n  animation-timing-function: cubic-bezier(0.65, -0.25, 0.38, 1.19);\n  animation-fill-mode: forwards;\n\n  .ant-card-body {\n    padding: 0px;\n  }\n\n  .ant-card-actions {\n    li {\n      margin: 0px;\n    }\n  }\n\n  .ant-card-actions {\n    padding: ", "px;\n    background: ", ";\n\n    li {\n      margin: 0px;\n    }\n  }\n"])), fadeDown, function (props) {
    /* We want to delay the animation on subsequent components */
    return calcLogarithmicGrowth(0.2, 0.5, 0.5, props.index + 1);
}, function (_a) {
    var token = _a.token;
    return token.paddingXS;
}, function (_a) {
    var token = _a.token;
    return token.colorBgLayout;
});
var SpaceCardBody = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-direction: row;\n  gap: 12px;\n\n  justify-content: space-between;\n  align-self: flex-start;\n  align-items: center;\n  padding: 12px;\n"], ["\n  flex-direction: row;\n  gap: 12px;\n\n  justify-content: space-between;\n  align-self: flex-start;\n  align-items: center;\n  padding: 12px;\n"])));
var SpaceInfo = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  flex-direction: column;\n  gap: 4px;\n"])));
var SpaceImage = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 4px;\n  object-fit: cover;\n"], ["\n  border-radius: 4px;\n  object-fit: cover;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
